











































































































































































































import MediaItem from './MediaItem/MediaItem.vue'
import FileIcon from './FileIcon.vue'
import { defineComponent, ref, computed } from '@vue/composition-api'
import { mediaItemFileVersionLink } from '@/shared/api'
import { MediaItem as IMediaItem } from '@/shared/types'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import {
  EDIT_MEDIA_ITEM,
  DELETE_MEDIA_ITEM,
  CREATE_MEDIA_ITEM_OCCURENCE,
} from '@/shared/user/permissions'
import { pagination, formatTimestamp } from '@/shared/utils'
export default defineComponent({
  name: 'MediaLibraryTable',
  components: {
    MediaItem,
    FileIcon,
  },
  props: {
    items: Array,
    search: String,
    loading: Boolean,
    draggable: Boolean,
    dragLoading: Boolean,
    page: Number,
    value: Array,
    total: Number,
    sortBy: Array,
    sortDesc: Boolean,
    textbookIssue: Object,
    headers: Array,
  },
  setup(props, { root, emit }) {
    const availableHeaders = computed(() => [
      {
        text: '',
        value: 'type',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.filename') as string,
        value: 'filename',
      },
      {
        text: root.$t('mediaLibrary.table.textbookIssue') as string,
        value: 'textbookIssue',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.name') as string,
        value: 'name',
      },
      {
        text: root.$t('mediaLibrary.table.category') as string,
        value: 'category',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.description') as string,
        value: 'description',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.licenses') as string,
        value: 'licenses',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.isDownloadable') as string,
        value: 'isDownloadable',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.pages') as string,
        value: 'pages',
        sortable: false,
      },
      {
        text: root.$t('mediaLibrary.table.file') as string,
        value: 'file',
        sortable: false,
      },
      {
        sortable: false,
        text: root.$t('actions') as string,
        value: 'actions',
      },
    ])

    const computedHeaders = computed(() => {
      if (!(props.headers && props.headers.length > 0)) {
        return availableHeaders.value
      }

      return availableHeaders.value.filter((header) =>
        props.headers.includes(header.value)
      )
    })

    const { hasPermissionTo } = useUserStore().getters
    const getFileVersionLink = mediaItemFileVersionLink
    const dataTable = ref(null)

    const joinIsbns = (mediaItem: IMediaItem) =>
      [
        ...new Set(
          mediaItem.occurences.map((item) =>
            item.textbookIssueIsbn.substring(4)
          )
        ),
      ]
        .sort()
        .join(', ')

    const ghostImageId = 'ghost-drag-image'

    const onDragStart = (e: DragEvent, data: string) => {
      e.dataTransfer.dropEffect = 'copy'
      let eventData = data
      if (props.value && props.value.length) {
        const dragImage = document.createElement('div')
        dragImage.id = ghostImageId
        const classes = [...dataTable.value.$el.classList]
        classes.forEach((className: string) => {
          dragImage.classList.add(className)
        })
        const ids: Array<string> = []
        ;(props.value as Array<IMediaItem>).forEach((mediaItem: IMediaItem) => {
          const row = root.$el.querySelector(`[data-id="${mediaItem.id}"]`)
          dragImage.appendChild(row.cloneNode(true))
          ids.push(mediaItem.id)
        })
        document.body.appendChild(dragImage)
        e.dataTransfer.setDragImage(dragImage, 0, 0)
        eventData = ids.join(',')
        e.dataTransfer.setData('text/plain', eventData)
      } else {
        e.dataTransfer.setData('text/plain', eventData)
      }
      emit('drag', eventData)
    }

    const onDragEnd = () => {
      const ghostImage = document.getElementById(ghostImageId)
      if (ghostImage) {
        document.body.removeChild(ghostImage)
      }
    }

    const replaceSearchText = (text: string, search: string) => {
      if (typeof text !== 'string' || !search) {
        return text
      }
      const regex = new RegExp(search, 'gi')
      return text.replace(
        regex,
        (a: string) => `<span class="highlight-text">${a}</span>`
      )
    }

    const filenameEllipsis = (filename: string, length: number) => {
      const ellipsis = '...'
      if (filename.length < length) {
        return filename
      }
      const parts = filename.split(".").filter(el => !!el)
      const extension = parts.length ? parts[parts.length - 1] : ""
      return filename.substring(0, length - extension.length - ellipsis.length) + ellipsis + extension
    }
  
    const linkEllipsis = (filename: string, length: number) => {
      const ellipsis = '...'
      if (filename.length < length) {
        return filename
      }
      return filename.substring(0, length - ellipsis.length) + ellipsis
    }

    return {
      computedHeaders,
      onDragStart,
      onDragEnd,
      filenameEllipsis,
      linkEllipsis,
      getFileVersionLink,
      dataTable,
      replaceSearchText,
      hasPermissionTo,
      EDIT_MEDIA_ITEM,
      DELETE_MEDIA_ITEM,
      CREATE_MEDIA_ITEM_OCCURENCE,
      pagination,
      joinIsbns,
      formatTimestamp,
    }
  },
})
